export const USERS_REGISTER = '/register/users';
export const OEC_APPROVED = '/approved/oec';
export const EMPLOYEES_REGISTER = '/employee';
export const COMMON_POLITICAL_DIVISION = '/common/politicalDivision';
export const ACCREDITATION_PROCESS = '/accreditations/process';
export const RESPONSE_FINDINGS_PROCESS = '/accreditations/process/responseFindings';
export const EVALUATION_TESTIFIED = '/accreditations/process/evaluationTestified';
export const TESTIFICATION = '/accreditations/process/testification';
export const TREASURY = '/treasury/deposits';
export const NON_CONFORMITIES_EVALUATION = '/accreditations/process/nonConformitiesEvaluation';
export const NON_COMFORMITES_TEMPLATE = '/technicalReviewer/non-conformities-template';
export const ELABORATE_ACTION_PLAN = '/accreditations/elaboration/action-plan';
